import { InfoArticle, Loader, ModalParts } from 'BreetComponents';
import { alwaysRefetchApiQueryOptions } from 'BreetHelpers';
import { useFormStage } from 'BreetHooks';
import { useGetSavedWalletAddressesQuery } from 'BreetRedux';
import type { FC } from 'react';

import Form from './components/form/Form';
import { CurrencyConverterProvider } from './components/FormProvider';
import { CurrencyConverterFormStageContext } from './components/FormStageContext';
import SendFiatTransactionDetails from './components/SendFiatTransactionDetails';
import { buyCryptoStageTitle, type CURRENCYCONVERTERSTAGESTYPE } from './DialogCurrencyConverter.helpers';

const DialogCurrencyConverter = () => {
	const { isFetching: isFetchingSavedWalletAddress } = useGetSavedWalletAddressesQuery(undefined, alwaysRefetchApiQueryOptions);

	const formStage = useFormStage<CURRENCYCONVERTERSTAGESTYPE>(
		'convert-currency',
		['convert-currency', 'transaction-details'],
		buyCryptoStageTitle
	);

	const { isStageActive, stageTitle, navigator } = formStage;

	const stageComponents: Record<CURRENCYCONVERTERSTAGESTYPE, FC> = {
		'convert-currency': Form,
		'transaction-details': SendFiatTransactionDetails,
	};

	return (
		<CurrencyConverterFormStageContext.Provider value={formStage}>
			<CurrencyConverterProvider>
				{isFetchingSavedWalletAddress ? (
					<Loader bgClassName='bg-primary-500' />
				) : (
					<ModalParts.Wrapper
						title={stageTitle}
						rightSheet
						root={buyCryptoStageTitle['convert-currency']}
						handleBackLink={navigator.historyBack}
					>
						{Object.entries(stageComponents).map(([stage, Component]) => (
							<ModalParts.Stage
								hide={!isStageActive(stage as CURRENCYCONVERTERSTAGESTYPE)}
								key={stage}
							>
								<Component />
							</ModalParts.Stage>
						))}

						<InfoArticle
							articleNumber='15947563'
							text='How does conversion work?'
						/>
					</ModalParts.Wrapper>
				)}
			</CurrencyConverterProvider>
		</CurrencyConverterFormStageContext.Provider>
	);
};

export default DialogCurrencyConverter;
